import { useState, useEffect } from 'react';

/**
 * Custom hook to manage capacity constraints
 */
export const useCapacity = (externalMaxCapacity, onMaxCapacityChange) => {
  // Internal max capacity state - only used if no external handler is provided
  const [internalMaxCapacity, setInternalMaxCapacity] = useState(externalMaxCapacity || 0);
  
  // Sync internal state with external prop when it changes
  useEffect(() => {
    if (externalMaxCapacity !== undefined) {
      setInternalMaxCapacity(externalMaxCapacity);
    }
  }, [externalMaxCapacity]);
  
  // Handle max capacity change
  const handleMaxCapacityChange = (capacity) => {
    // Call external handler if provided
    if (onMaxCapacityChange) {
      onMaxCapacityChange(capacity);
    } else {
      setInternalMaxCapacity(capacity);
    }
  };
  
  // Get the actual maxCapacity value to use
  const actualMaxCapacity = externalMaxCapacity !== undefined ? externalMaxCapacity : internalMaxCapacity;
  
  return {
    internalMaxCapacity,
    actualMaxCapacity,
    handleMaxCapacityChange
  };
}; 